import { render } from "./ASContact.vue?vue&type=template&id=af57c0d8&scoped=true"
import script from "./ASContact.vue?vue&type=script&lang=js"
export * from "./ASContact.vue?vue&type=script&lang=js"

import "./ASContact.vue?vue&type=style&index=0&id=af57c0d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af57c0d8"]])

export default __exports__